import { render, staticRenderFns } from "./center1.vue?vue&type=template&id=3445c9e0&scoped=true"
import script from "./center1.vue?vue&type=script&lang=js"
export * from "./center1.vue?vue&type=script&lang=js"
import style0 from "./center1.vue?vue&type=style&index=0&id=3445c9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445c9e0",
  null
  
)

export default component.exports